export default function OptionsSection() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-white to-[#FAF0E6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16 space-y-4 sm:space-y-6">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2C2C2C]">スポット・オプションメニュー</h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#757575] max-w-3xl mx-auto">
            スポットでのサポート希望やさらに深く学びたい方へ
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto">
          <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#E8F5E9] rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-time-line text-3xl sm:text-4xl text-[#66BB6A]"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">対面サポートの追加またはスポット</h3>
            <p className="text-sm sm:text-base text-[#757575] mb-4 sm:mb-6 leading-relaxed">
              月3時間を超えた対面サポートまたはスポットでのサポート希望の場合
            </p>
            <div className="flex items-baseline gap-2 mb-4 sm:mb-6">
              <span className="text-3xl sm:text-4xl font-bold text-[#66BB6A]">¥1,200</span>
              <span className="text-sm sm:text-base text-[#757575]">/ 1時間</span>
            </div>
            <button className="w-full bg-[#F5F5F5] text-[#2C2C2C] py-3 rounded-full hover:bg-[#E8F5E9] hover:text-[#66BB6A] transition-all font-medium text-sm sm:text-base whitespace-nowrap cursor-pointer">
              詳細お問合せ
            </button>
          </div>
          <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#E8F5E9] rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-palette-line text-3xl sm:text-4xl text-[#66BB6A]"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">CANVA 深堀りサポート</h3>
            <p className="text-sm sm:text-base text-[#757575] mb-4 sm:mb-6 leading-relaxed">
              動画編集など、Canvaの応用機能を集中的に学べます
            </p>
            <div className="flex items-baseline gap-2 mb-4 sm:mb-6">
              <span className="text-3xl sm:text-4xl font-bold text-[#66BB6A]">¥5,800</span>
              <span className="text-sm sm:text-base text-[#757575]">/ 2時間×3回</span>
            </div>
            <button className="w-full bg-[#F5F5F5] text-[#2C2C2C] py-3 rounded-full hover:bg-[#E8F5E9] hover:text-[#66BB6A] transition-all font-medium text-sm sm:text-base whitespace-nowrap cursor-pointer">
              詳細お問合せ
            </button>
          </div>
          <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all md:col-span-2 lg:col-span-1">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#E8F5E9] rounded-2xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-global-line text-3xl sm:text-4xl text-[#66BB6A]"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">BASE（ネットショップ）立ち上げサポート</h3>
            <p className="text-sm sm:text-base text-[#757575] mb-4 sm:mb-6 leading-relaxed">
              無料ネットショップツールBASEでの初期設定、商品登録支援・通販フロー支援などをサポート
            </p>
            <div className="flex items-baseline gap-2 mb-4 sm:mb-6">
              <span className="text-3xl sm:text-4xl font-bold text-[#66BB6A]">¥5,800</span>
              <span className="text-sm sm:text-base text-[#757575]">/ 2時間×3回</span>
            </div>
            <button className="w-full bg-[#F5F5F5] text-[#2C2C2C] py-3 rounded-full hover:bg-[#E8F5E9] hover:text-[#66BB6A] transition-all font-medium text-sm sm:text-base whitespace-nowrap cursor-pointer">
              詳細お問合せ
            </button>
          </div>
        </div>
        <div className="mt-12 sm:mt-16 text-center">
          <div className="inline-block bg-white rounded-2xl px-6 sm:px-8 py-4 sm:py-6 shadow-md">
            <p className="text-sm sm:text-base text-[#757575] leading-relaxed">
              <i className="ri-information-line text-lg sm:text-xl text-[#66BB6A] mr-2"></i>
              詳しくお気軽にご相談ください
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
